<template>
<div class="col-md-12">
    <b-card header="Ranking de Revendedoras">
        <b-card-body>
            <div class="col-md-12 printer">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">De:</label>
                            <date-picker v-model="dataDe" @dp-change="loadRenvededoras" :config="datePickerConfig"></date-picker>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Até:</label>
                            <date-picker v-model="dataAte" @dp-change="loadRenvededoras" :config="datePickerConfig"></date-picker>
                        </div>
                    </div>
                    <div class="col">
                        <json-excel :data="showRevendedoras" v-if="showRevendedoras.length > 0" worksheet="Ranking Revendedoras" :name="filename">
                            <b-button variant="success" class="float-right" size="sm"> Exportar <i class="far fa-file-excel"></i> </b-button>
                        </json-excel>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <b-table striped hover :fields="colunas" :busy="loading" :items="showRevendedoras" :current-page="currentPage" :per-page="perPage" stacked="md" show-empty small>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Carregando...</strong>
                                </div>
                            </template>
                        </b-table>
                        <b-pagination v-if="showRevendedoras.length > 19" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </div>
                </div>
            </div>
        </b-card-body>
    </b-card>
</div>
</template>

<script>
import moment from 'moment';
import JsonExcel from "vue-json-excel";
export default {
    name: "AdmRevendedora",
    components: {
        JsonExcel
    },
    data() {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            sortBy: 'valor',
            sortDesc: false,
            loading: false,
            revendedoras: [],
            dataAte: moment().format('DD/MM/YYYY'),
            dataDe: moment().subtract(30, 'days').format('DD/MM/YYYY'),
            datePickerConfig: {
                'format': 'DD/MM/YYYY',
                'showClose': true
            },
            colunas: [{
                    key: "revendedora",
                    label: "Revendedora",
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: "quantidade",
                    label: "Qtde. Itens",
                    sortable: false,
                    class: 'text-center'

                },
                {
                    key: "total",
                    label: "Valor R$",
                    formatter: (value) => {
                        return parseFloat(value).toFixed(2).toString().replace(".", ",")
                    },
                    sortable: true,
                    sortDirection: 'desc',
                    class: 'text-center'
                }
            ]
        }
    },
    methods: {
        loadRenvededoras() {
            var vm = this;
            $(".loading").show();
            vm.revendedoras = [];
            vm.loading = true;
            axios.get("/distribuidor/ranking/revendedora/list", {
                params: {
                    from: moment(this.dataDe, "DD/MM/YYYY").format("YYYY-MM-DD"),
                    to: moment(this.dataAte, "DD/MM/YYYY").format("YYYY-MM-DD"),
                }                
            }).then(function (response) {
                vm.revendedoras = response.data;                
                vm.totalRows = vm.revendedoras.length;
                vm.loading = false;
                $(".loading").hide();
            }).catch(function (error) {
                vm.loading = false;
                alert("Falha ao carregar os produtos");
                $(".loading").hide();
            });                        
        },
    },
    mounted() {               
        this.loadRenvededoras();
    },
    computed: {
        showRevendedoras() {
            var data = this.revendedoras;
            return data;
           
        },
        filename() {
            const data = new Date();
            return `${data.getTime()}.xls`;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor_ranking/Revendedora.vue